import Grid from "@mui/material/Grid2";
import {Box, Button, Container, Divider, Typography} from "@mui/material";
import ProjectCard from "./LightningCard";
import {motion, useAnimation, useInView} from "framer-motion";
import {useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";

const SectionWithItems = ({title, projects, extraLink}) => {
    const navigate = useNavigate();

    const ref = useRef(null);
    const controls = useAnimation();
    const isInView = useInView(ref, { once: false, amount: 0.2 }); // Detects if it's in view

    useEffect(() => {
        if (isInView) {
            controls.start({ opacity: 1, y: 0 });
        }
    }, [isInView, controls]); // Runs when the view state changes


    return (
        <Container>
            <Box sx={{
                paddingTop: '20px',
                paddingBottom: '40px',
                // py: 5,
                px: {xs: 3, md: 6},
                textAlign: "left",
                color: "white"
            }}>
                <motion.div
                    ref={ref}
                    transition={{duration: 0.3}}
                    initial={{ opacity: 0, y: 50 }}
                    animate={controls} // Now controlled by `useAnimation`
                    whileInView={{ opacity: 1, y: 0 }}
                >
                    <Box sx={{display: "flex", justifyContent: "space-between"}}>
                        <Box sx={{height: '100%', alignItems: 'center'}}>
                            {/* Title & Underline */}
                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: "bold",
                                    textTransform: "uppercase",
                                    fontFamily: `"Poppins", sans-serif`,
                                    display: "inline-block",
                                    fontSize: {xs: '14px', md:'24px'},
                                }}
                            >
                                {title}
                            </Typography>
                            <Divider
                                sx={{
                                    backgroundColor: "#FFD700", // Faint Gold Underline
                                    height: "2px",
                                    width: "80px",
                                    mt: 1,
                                    mb: 4,
                                    // mx: "auto",
                                }}
                            />
                        </Box>
                        {/* See More Button */}
                        {extraLink && (
                            <Box>
                                <Button
                                    // component={Link}
                                    onClick={() => navigate(extraLink)}
                                    variant="outlined"
                                    sx={{
                                        color: "#FFD700",
                                        borderColor: "#FFD700",
                                        fontWeight: "bold",
                                        textTransform: "none",
                                        "&:hover": {
                                            backgroundColor: "#FFD700",
                                            color: "#1e1e1e",
                                        },
                                    }}
                                >
                                    See More
                                </Button>
                            </Box>
                        )}
                    </Box>
                </motion.div>
                <Grid container spacing={{xs: 2, md: 4}} justifyContent="center">
                    {projects.map((project, index) => (
                        <Grid key={index} size={{lg: 6, md: 6, sm: 6, xs: 12}}>
                            <ProjectCard project={project}/>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Container>
    );
};

export default SectionWithItems;